<template>
    <div>
        <h3 @click="enableDebug($event)" class="display-4">Manage Groups</h3>

        <o-list-toolbar
            :filters-list="filter_list"
            :list-options="list_options"
            :new-to="{ name: 'group.create', params: { id: 0 } }"
            :query-select-options="options"
            :schema="schema"
            :search-fields-list="search_field_list"
            :selected-filter="selected_filter"
            @filter_changed="update_filter($event)"
            @options_changed="update_table($event)"
            @reset_table="reset_table"
            new-button-text="New Group"
        >
        </o-list-toolbar>

        <b-table
            :fields="fields"
            :items="items"
            :sort-by="list_options.sort"
            :sort-desc="list_options.order == 'desc'"
            @sort-changed="change_sort"
            bordered
            head-variant="light"
            no-local-sorting
            striped
        >
            <template slot="cell(name)" slot-scope="{ index, item }">
                <router-link
                    :to="{ name: 'group.edit', params: { id: item.id } }"
                >
                    <default-display :value="item.name"></default-display>
                </router-link>
            </template>

            <template slot="empty">
                <p>
                    <emoticon-sad-icon large></emoticon-sad-icon>
                </p>
                No Data Found. Please
                <router-link :to="{ name: 'group.create' }"
                    >create a new item</router-link
                >
            </template>
        </b-table>

        <o-list-paging
            :limit="list_options.limit"
            :offset="list_options.offset"
            :page-options="rows_per_page_items"
            :total-items="total_items"
            @change-limit="change_limit"
            @change-page="change_page"
        />
    </div>
</template>

<style></style>

<script>
import {
    CreateCodeTableFetchMixin,
    CreateGroupPermissionMixin,
    CreateListPageMixin,
} from "../../../mixins";
import {
    fieldToTableColumn,
    GetSearchFields,
} from "../../../schema/schema_utils";
import schema from "../../schema/index";

import OListToolbar from "../../../components/list/OListToolbar";
import OListPaging from "../../../components/list/OListPaging";
import DefaultDisplay from "../../../components/display/DefaultDisplay";
import DateDisplay from "../../../components/display/DateDisplay";
import NumberDisplay from "../../../components/display/NumberDisplay";
import BooleanDisplay from "../../../components/display/BooleanDisplay";
import LookupDisplay from "../../../components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
    components: {
        EmoticonSadIcon,
        EmailIcon,
        LinkIcon,
        OListPaging,
        OListToolbar,
        DateDisplay,
        DefaultDisplay,
        BooleanDisplay,
        NumberDisplay,
        LookupDisplay,
    },
    mixins: [
        CreateListPageMixin("Group", "group"),
        CreateGroupPermissionMixin("Group"),
        CreateCodeTableFetchMixin([]),
    ],

    data: function () {
        return {
            schemaModel: schema.Group,

            search_field_list: GetSearchFields(schema.Group),

            filter_list: [
                {
                    name: "All",
                    code: "all",
                    options: { offset: 0, sort: "name" },
                },
            ],
        };
    },
    computed: {
        options() {
            return {};
        },
        fields() {
            return [fieldToTableColumn(this.schema, "name")];
        },
    },
};
</script>
